import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TASK_SERVICE } from '@eggplant/api-hosts'
import type { ReactElement } from 'react'

interface Props {
  children?: () => ReactElement
}

const PingTaskService = ({
  children
}: Props) => {
  const url = `${TASK_SERVICE}/ping`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      url={url}
    />
  )
}

export default PingTaskService
